// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text, TilingSprite, NineSlicePlane, Graphics } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: '3ec5b3bb-c05d-4bbf-9db5-0990b15d176a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '8ce44f45-d88e-448d-8f41-1f9de8737bb1',
      type: 'Sprite',
      name: 'blackOverlay',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 10,
        y: 10
      },
      angle: 0,
      alpha: 0.8,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Square_White',
      parent: '3ec5b3bb-c05d-4bbf-9db5-0990b15d176a',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: 'e08fbc37-63c9-49ab-9ce8-c66727616f05',
      type: 'Sprite',
      name: 'helpGradient',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 25.6,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: '3ec5b3bb-c05d-4bbf-9db5-0990b15d176a',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: '7d0cb668-eca3-4d30-9bfc-f2d6cd28c772',
      type: 'Sprite',
      name: '',
      className: '',
      x: 800,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Screen_Landscape',
      parent: '3ec5b3bb-c05d-4bbf-9db5-0990b15d176a',
      data: {
        DEBUG: true
      }
    },
    {
      id: '6ca15947-877d-4bc4-a911-75f53d87bdef',
      type: 'Container',
      name: 'imageSlot',
      className: '',
      x: 0,
      y: 155,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3ec5b3bb-c05d-4bbf-9db5-0990b15d176a'
    },
    {
      id: '87b1cdea-80bb-4d25-bee9-4b6535af24a5',
      type: 'Container',
      name: 'helpDescriptionWrapper',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 937,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3ec5b3bb-c05d-4bbf-9db5-0990b15d176a',
      data: {
        dynamicValues: {
          y: 'height * 0.73'
        }
      }
    },
    {
      id: 'c50cb813-fa52-4920-b52f-a875f60e2711',
      type: 'Container',
      name: 'rewardsContainer',
      className: '',
      x: 0,
      y: 321,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3ec5b3bb-c05d-4bbf-9db5-0990b15d176a'
    },
    {
      id: '5c82204e-85ff-4683-953a-c6ae597137ec',
      type: 'Container',
      name: 'topButtonsContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3ec5b3bb-c05d-4bbf-9db5-0990b15d176a'
    },
    {
      id: 'd521aa44-3e82-465b-8af0-089032454c9f',
      type: 'Container',
      name: 'titleContainer',
      className: '',
      x: 0,
      y: 384,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3ec5b3bb-c05d-4bbf-9db5-0990b15d176a'
    },
    {
      id: '0dadde3c-6def-4d71-9782-92c8219b3bd0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Image_Forest',
      parent: '6ca15947-877d-4bc4-a911-75f53d87bdef',
      data: {
        DEBUG: true
      }
    },
    {
      id: '20aca76d-7b69-4cda-9a4e-61b5a200524d',
      type: 'Text',
      name: 'instructionText',
      className: 'colorTags_SPL',
      x: 0,
      y: -202,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'instructions',
      localize: false,
      maxWidth: 500,
      maxHeight: 200,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 500,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '87b1cdea-80bb-4d25-bee9-4b6535af24a5',
      data: {
        colorTags: {}
      }
    },
    {
      id: '8a9512b6-c42f-4c6c-9f94-038c70d33c84',
      type: 'Text',
      name: 'description2',
      className: 'colorTags_SPL',
      x: 0,
      y: -23,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Complete all tiers to win the $Top Prize$!',
      localize: true,
      maxWidth: 500,
      maxHeight: 200,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 500,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '87b1cdea-80bb-4d25-bee9-4b6535af24a5',
      data: {
        colorTags: {
          $: '#ffd200'
        }
      }
    },
    {
      id: '0f21a2df-371d-46bf-810e-d22b475576c2',
      type: 'Layout',
      name: 'letsGoButton',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 168,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      parent: '87b1cdea-80bb-4d25-bee9-4b6535af24a5',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'e5139703-a14e-426e-ac5b-2eb8a6d6a621',
      type: 'Sprite',
      name: 'blueBackground',
      className: '',
      x: -420,
      y: 259,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 6.5625,
        y: 15.625
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 663675,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Square_White',
      parent: 'c50cb813-fa52-4920-b52f-a875f60e2711'
    },
    {
      id: 'a99fd21b-bd73-4527-a4f6-c92e4ce0743e',
      type: 'Sprite',
      runtimeType: 'TilingSprite',
      name: '',
      className: '',
      x: -414,
      y: 268,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 6.335878,
        y: 11.173184
      },
      angle: 0,
      alpha: 0.3,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Pattern_Star',
      parent: 'c50cb813-fa52-4920-b52f-a875f60e2711'
    },
    {
      id: '21cc8bcf-a72b-4db1-bbd7-2737f975f345',
      type: 'Container',
      name: 'contentSlot',
      className: '',
      x: 0,
      y: 270,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c50cb813-fa52-4920-b52f-a875f60e2711'
    },
    {
      id: '63de2642-2b06-4c44-b459-9964305b63b5',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -415,
      y: 101,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 830,
      height: 209,
      leftWidth: 0,
      topHeight: 0,
      rightWidth: 0,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Band_Brown',
      parent: 'c50cb813-fa52-4920-b52f-a875f60e2711'
    },
    {
      id: '335901a6-f91b-4487-ba88-c21d205c307d',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -415,
      y: 36,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 830,
      height: 77,
      leftWidth: 0,
      topHeight: 0,
      rightWidth: 0,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Band_Yellow',
      parent: 'c50cb813-fa52-4920-b52f-a875f60e2711'
    },
    {
      id: 'cea42bff-ce45-432e-b8df-cb75d1c78768',
      type: 'NineSlicePlane',
      name: 'frame',
      className: '',
      x: -430,
      y: 24,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 860,
      height: 2000,
      leftWidth: 30,
      topHeight: 30,
      rightWidth: 30,
      bottomHeight: 30,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Frame_Gold_9Slice_30_30_30_35',
      parent: 'c50cb813-fa52-4920-b52f-a875f60e2711'
    },
    {
      id: 'ca1a919e-7c3c-4b99-8355-b7dbff594b72',
      type: 'Container',
      name: 'progressBarSlot',
      className: '',
      x: 0,
      y: 194,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c50cb813-fa52-4920-b52f-a875f60e2711'
    },
    {
      id: '450b8e22-f813-457a-b7d3-ba2d6dccf4e6',
      type: 'Graphics',
      name: 'contentSlotMask',
      className: '',
      x: 0,
      y: 270,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c50cb813-fa52-4920-b52f-a875f60e2711',
      commands: [
        {
          id: '88591aed-f904-4cab-9878-a321adc0f40a',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        },
        {
          id: 'd417861a-077a-4314-aa36-44ab80fec442',
          type: 'drawRect',
          x: -415,
          y: 0,
          width: 830,
          height: 2000
        },
        {
          id: '753ca736-0003-477f-97d1-4d02f1773178',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        }
      ]
    },
    {
      id: 'dc763b7d-fc45-4fa1-9699-207364595a27',
      type: 'Sprite',
      name: 'scrollInput',
      className: '',
      x: 0,
      y: 269,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -415,
        y: 0,
        width: 830,
        height: 5000
      },
      texture: '',
      parent: 'c50cb813-fa52-4920-b52f-a875f60e2711'
    },
    {
      id: 'e5297244-993d-415e-b25e-391674f288af',
      type: 'Sprite',
      name: 'helpButton',
      className: '',
      x: -317,
      y: 67,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Help',
      parent: '5c82204e-85ff-4683-953a-c6ae597137ec'
    },
    {
      id: 'c826a0c3-dfe8-409f-b0a5-5d82acafcee0',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 317,
      y: 67,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Shop_Close_Button',
      parent: '5c82204e-85ff-4683-953a-c6ae597137ec'
    },
    {
      id: '3c0badc6-e64d-4086-b876-d49e60425300',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -225,
      y: -67,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 450,
      height: 136,
      leftWidth: 55,
      topHeight: 5,
      rightWidth: 55,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Title_Background_9Slice_55x0x55x0',
      parent: 'd521aa44-3e82-465b-8af0-089032454c9f'
    },
    {
      id: 'fdc23d64-e6df-4ded-86a9-fcaa3c03d1e4',
      type: 'Text',
      name: 'eventTitle',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Event Title',
      localize: false,
      maxWidth: 340,
      maxHeight: 100,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0038f0',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd521aa44-3e82-465b-8af0-089032454c9f'
    },
    {
      id: 'a2e1f533-7fb7-4c37-add0-e9d5d07667dc',
      type: 'Sprite',
      name: 'buttonGlow',
      className: '',
      x: 0,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.543103,
        y: 0.431034
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '0f21a2df-371d-46bf-810e-d22b475576c2'
    },
    {
      id: '5cd68ff5-bf21-4982-9d07-4f8b05608a00',
      type: 'Text',
      name: 'greenButtonText',
      className: 'upperCase_SPL',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Let\'s go!',
      localize: true,
      maxWidth: 350,
      maxHeight: 90,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#006100',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0f21a2df-371d-46bf-810e-d22b475576c2'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: 'e31f6a9e-e064-485e-90a6-cdea286974d3',
      name: 'SwitchToHelp',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: '2cf1852f-baa6-4d50-bf8a-c16b6f65aebc',
          type: 'Tween',
          name: 'gradientFadeIn',
          duration: 300,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'helpGradient',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'ff9badaf-338c-4fd5-a568-4a9618d2a611',
          type: 'Tween',
          name: 'rewardViewOut',
          duration: 300,
          track: 2,
          target: {
            pivot: {
              y: -1400
            },
            alpha: 0
          },
          startAt: 0,
          sourceName: 'rewardsContainer',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: '8f25578f-7e72-49d5-bb04-f155e2862231',
          type: 'Tween',
          name: 'buttonsOut',
          duration: 300,
          track: 3,
          target: {
            pivot: {
              y: 200
            }
          },
          startAt: 0,
          sourceName: 'topButtonsContainer',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: '142fe15e-6b11-4917-913d-4783f46dc69d',
          type: 'Tween',
          name: 'imagePosition',
          duration: 300,
          track: 5,
          target: {
            pivot: {
              y: -150
            }
          },
          startAt: 0,
          sourceName: 'imageSlot',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'd4e44629-93e6-4a6b-90de-12599acf36b2',
          type: 'Tween',
          name: 'titlePosition',
          duration: 300,
          track: 4,
          target: {
            pivot: {
              y: -150
            }
          },
          startAt: 0,
          sourceName: 'titleContainer',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: '1b8ec471-d7c0-48d2-8a2b-c55d4461f06b',
          type: 'Tween',
          name: 'helpFadeIn',
          duration: 300,
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'helpDescriptionWrapper',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '5743ddd2-ea4d-4e5e-b2a4-5e121a18d451',
          type: 'Tween',
          name: 'blackOverlayAlpha',
          duration: 300,
          track: 7,
          target: {
            alpha: 0.3
          },
          startAt: 0,
          sourceName: 'blackOverlay',
          easing: 'Linear',
          disabled: false
        }
      ]
    },
    {
      id: 'c3acdc73-b18a-4cb3-8c76-3928261e6feb',
      name: 'SwitchToReward',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: '2cf1852f-baa6-4d50-bf8a-c16b6f65aebc',
          type: 'Tween',
          name: 'gradientFadeIn',
          duration: 300,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'helpGradient',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'ff9badaf-338c-4fd5-a568-4a9618d2a611',
          type: 'Tween',
          name: 'rewardViewOut',
          duration: 300,
          track: 2,
          target: {
            pivot: {
              y: 0
            },
            alpha: 1
          },
          startAt: 0,
          sourceName: 'rewardsContainer',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: '8f25578f-7e72-49d5-bb04-f155e2862231',
          type: 'Tween',
          name: 'buttonsOut',
          duration: 300,
          track: 3,
          target: {
            pivot: {
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'topButtonsContainer',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: '142fe15e-6b11-4917-913d-4783f46dc69d',
          type: 'Tween',
          name: 'imagePosition',
          duration: 300,
          track: 5,
          target: {
            pivot: {
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'imageSlot',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'd4e44629-93e6-4a6b-90de-12599acf36b2',
          type: 'Tween',
          name: 'titlePosition',
          duration: 300,
          track: 4,
          target: {
            pivot: {
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'titleContainer',
          easing: 'QuadraticOut',
          disabled: false
        },
        {
          id: 'd26b4927-64d8-47b3-8df7-a0a733a303b1',
          type: 'Tween',
          name: 'helpFadeOut',
          duration: 300,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'helpDescriptionWrapper',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: '86538ea3-e6c4-4b8c-babe-26eac075aeb9',
          type: 'Tween',
          name: 'blackOverlayAlpha_1',
          duration: 300,
          track: 7,
          target: {
            alpha: 0.8
          },
          startAt: 0,
          sourceName: 'blackOverlay',
          easing: 'Linear',
          disabled: false
        }
      ]
    },
    {
      id: '1ed937ee-5f35-49bb-bed5-e7999dc7efbf',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: 'a3191d20-3752-4bc3-9eec-2d920423b77b',
          type: 'Setter',
          name: 'rootAlphaSetter',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '34f3b3c6-a36a-4aef-a23b-808b2167b417',
          type: 'Tween',
          name: 'rootAlphaTween',
          duration: 300,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'CubicOut',
          disabled: false
        }
      ]
    },
    {
      id: '7ee69ff2-579d-40f0-964c-867722ff4fa7',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: 'ef36d911-48ef-4a7d-8199-b95111fd64a0',
          type: 'Tween',
          name: 'buttonScale',
          duration: 1000,
          track: 3,
          target: {
            scale: {
              y: 1.06,
              x: 1.06
            }
          },
          startAt: 0,
          sourceName: 'letsGoButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '92680ea9-cde3-4b1c-ab8b-287d9f3a1e67',
          type: 'Tween',
          name: 'glow',
          duration: 1000,
          track: 2,
          target: {
            alpha: 0.5
          },
          startAt: 0,
          sourceName: 'buttonGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4bd3f32f-0b35-40ba-be67-d1886d559922',
          type: 'Tween',
          name: 'glow_copy',
          duration: 1000,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 1000,
          sourceName: 'buttonGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '1bfe2671-83ed-4c16-8aaa-49fa4ad6b65b',
          type: 'Tween',
          name: 'buttonScale_copy',
          duration: 1000,
          track: 3,
          target: {
            scale: {
              y: 1,
              x: 1
            }
          },
          startAt: 1000,
          sourceName: 'letsGoButton',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class CollectEventPopupLayout {
  static raw = raw;
  root!: Container;
  blackOverlay!: Sprite & { data: typeof raw['list'][1]['data'] };
  helpGradient!: Sprite & { data: typeof raw['list'][2]['data'] };
  imageSlot!: Container;
  helpDescriptionWrapper!: Container & { data: typeof raw['list'][5]['data'] };
  rewardsContainer!: Container;
  topButtonsContainer!: Container;
  titleContainer!: Container;
  instructionText!: Text & { data: typeof raw['list'][10]['data'] };
  description2!: Text & { data: typeof raw['list'][11]['data'] };
  letsGoButton!: ButtonExtraLargeLayout & { data: typeof raw['list'][12]['data'] };
  blueBackground!: Sprite;
  contentSlot!: Container;
  frame!: NineSlicePlane;
  progressBarSlot!: Container;
  contentSlotMask!: Graphics;
  scrollInput!: Sprite;
  helpButton!: Sprite;
  closeButton!: Sprite;
  eventTitle!: Text;
  buttonGlow!: Sprite;
  greenButtonText!: Text;
  dynamicProps_SPL!: (Sprite & { data: typeof raw['list'][1]['data'] } | Sprite & { data: typeof raw['list'][2]['data'] } | Container & { data: typeof raw['list'][5]['data'] })[];
  colorTags_SPL!: (Text & { data: typeof raw['list'][10]['data'] } | Text & { data: typeof raw['list'][11]['data'] })[];
  upperCase_SPL!: (Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class SwitchToHelp {
  Layout: {
    helpGradient: object;
    rewardsContainer: object;
    topButtonsContainer: object;
    imageSlot: object;
    titleContainer: object;
    helpDescriptionWrapper: object;
    blackOverlay: object;
  };

  BlockTypeByName: {
    gradientFadeIn: object;
    rewardViewOut: object;
    buttonsOut: object;
    imagePosition: object;
    titlePosition: object;
    helpFadeIn: object;
    blackOverlayAlpha: object;
  };

  flowData = raw.animations[0];
}

export abstract class SwitchToReward {
  Layout: {
    helpGradient: object;
    rewardsContainer: object;
    topButtonsContainer: object;
    imageSlot: object;
    titleContainer: object;
    helpDescriptionWrapper: object;
    blackOverlay: object;
  };

  BlockTypeByName: {
    gradientFadeIn: object;
    rewardViewOut: object;
    buttonsOut: object;
    imagePosition: object;
    titlePosition: object;
    helpFadeOut: object;
    blackOverlayAlpha_1: object;
  };

  flowData = raw.animations[1];
}

export abstract class Appear {
  Layout: {
    root: object;
  };

  BlockTypeByName: {
    rootAlphaSetter: object;
    rootAlphaTween: object;
  };

  flowData = raw.animations[2];
}

export abstract class Idle {
  Layout: {
    letsGoButton: object;
    buttonGlow: object;
  };

  BlockTypeByName: {
    buttonScale: object;
    glow: object;
    glow_copy: object;
    buttonScale_copy: object;
  };

  flowData = raw.animations[3];
}
